import { useEffect, useState } from 'react'

export interface Props {
  src?: string,
  alt?: string,
  color: string
}

const getInitial = (text: string): string => {
  const trimText = text.trim()

  return trimText.length > 0
    ? trimText[0]
    : 'a'
}

const Avatar = ({ alt = 'anonymous', color, src }: Props) => {
  const [imageFailed, setImageFailed] = useState<boolean>(false)
  const [initial, setInitial] = useState<string>(getInitial(alt))
  const iconNameStyle = { backgroundColor: color }
  const showImage = src && !imageFailed

  const handleError = () => {
    setImageFailed(true)
  }

  useEffect(
    () => {
      setInitial(getInitial(alt))
    },
    [alt]
  )

  return showImage
    ? (
      <div className="photo">
        <img alt={alt} src={src} onError={handleError} />
      </div>
    )
    : (
      <span className="icon-name" style={iconNameStyle}>
        {initial}
      </span>
    )
}

export default Avatar
